import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | Zero Harm AI"
        description="The page you're looking for doesn't exist or has moved."
        noindex
      />

      <div className="max-w-4xl mx-auto px-4 py-20 text-center text-gray-700">
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Page not found
        </h1>
        <p className="mb-8">
          The page you're looking for doesn't exist or has moved.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-blue-700 text-white rounded-lg hover:bg-blue-800 font-semibold"
        >
          Back to home
        </Link>
      </div>
    </>
  );
}
